import { render, staticRenderFns } from "./ListviewOld.vue?vue&type=template&id=674ce73c&scoped=true"
import script from "./ListviewOld.vue?vue&type=script&lang=js"
export * from "./ListviewOld.vue?vue&type=script&lang=js"
import style0 from "./ListviewOld.vue?vue&type=style&index=0&id=674ce73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ce73c",
  null
  
)

export default component.exports